import {
  InputButtonGroup,
  InputMask,
  InputText,
  FormField,
  FormRow,
} from "@endya-conformite/ui-kit";
import { GatewayContact } from "@conformite/gateway";
import { civiliteMediationOptions } from "@src/societes/form/EntrepriseContactMediationForm";
import { SocieteInformationFormBloc } from "./SocieteInformationFormBloc";
import { SocieteInformationFormValues } from "../useSocieteInformation";

type ContactMediationInformationProps = {
  nomMediationPlaceholder: string;
};

export function ContactMediationInformation({
  nomMediationPlaceholder,
}: ContactMediationInformationProps) {
  return (
    <SocieteInformationFormBloc title="Contact de médiation">
      <FormRow>
        <FormField>
          <InputButtonGroup<
            SocieteInformationFormValues,
            false,
            GatewayContact.ContactCivilite
          >
            name="civiliteMediation"
            label="Civilité"
            options={civiliteMediationOptions}
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputText<SocieteInformationFormValues>
            label="Nom"
            name="nomMediation"
            placeholder={nomMediationPlaceholder}
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputText<SocieteInformationFormValues>
            label="Prénom"
            name="prenomMediation"
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputText<SocieteInformationFormValues>
            label="Email"
            name="mailMediation"
            required
          />
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <InputMask
            name="telephoneMediation"
            mask="99 99 99 99 99"
            label="Téléphone"
          />
        </FormField>
      </FormRow>
    </SocieteInformationFormBloc>
  );
}
